import packageInfo from '../../../package.json';
import { namespace } from '../common/Utils';
import Share from './index';

namespace('ncui');
if (!window.ncui.ver) window.ncui.ver = packageInfo.version;
window.ncui.share = Share;

if (module.hot) {
    module.hot.accept(function() {
      console.log('Accepting the updated printMe module!');
    })
  }
